import React from "react";

export const appointmentSettingsConfig = [
  {
    auth: ["user"],
    routes: [
      {
        path: "/appointment-types/add",
        component: React.lazy(() => import("./AppointmentTypes")),
      },
      {
        path: "/appointment-types",
        component: React.lazy(() => import("./AppointmentTypes")),
      },
       {
        path: "/services",
        component: React.lazy(() => import("./Services")),
      },
      {
        path: "/packages-plan",
        component: React.lazy(() => import("./packages-plan")),
      },
      {
        path: "/cancellation-policy",
        component: React.lazy(() => import("./CancellationPolicy")),
      },
    ],
  },
];
